import TechnicianPerfDownloader from "../data/technician/TechnicianPerfDownloader";

export function ExportDrawer() {
  return (
    <div className="p-4 h-[90%]">
      <TechnicianPerfDownloader />
    </div>
  );
} 